import React, { useState } from 'react';
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  Avatar,
  Flex,
  Text,
  Box,
  useColorModeValue,
  Divider,
} from '@chakra-ui/react';
import ProfileOptionsDrawer from './ProfileOptionsDrawer'; // Your Profile Options component
import DarkModeToggle from './DarkModeToggle'; // Import your DarkModeToggle component
import defProfile from './assets/default-user-pic.png';

const UserProfile = ({ userInfo }) => {
  const drawerBg = useColorModeValue('rcBrand.parchment', 'rcBrand.forest'); // Background color based on color mode
  const [isProfileDrawerOpen, setIsProfileDrawerOpen] = useState(false);

  const toggleProfileDrawer = () => {
    setIsProfileDrawerOpen(!isProfileDrawerOpen);
  };

  // Fallback values for name and photo
  const displayName = userInfo?.name || "Guest User";
  const displayPhoto = userInfo?.photo || defProfile;

  return (
    <>
      <Flex alignItems="center" cursor="pointer" onClick={toggleProfileDrawer}>
        {/* Fallback to "Guest User" if name is not available */}
        <Text mr={2}>{displayName}</Text> 

        {/* Fallback to default avatar image if profile photo is not available */}
        <Box>
          <Avatar name={displayName} src={displayPhoto} />
        </Box>
      </Flex>

      <Drawer placement="right" onClose={toggleProfileDrawer} isOpen={isProfileDrawerOpen} size="xs">
        <DrawerOverlay>
          <DrawerContent bg={drawerBg} borderRadius="lg" style={{ height: '25%', alignSelf: 'flex-start' }}>
            <DrawerCloseButton />
            <DrawerHeader fontSize="xl">Profile Options</DrawerHeader>
            <DrawerBody>
              <ProfileOptionsDrawer />
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </>
  );
};

export default UserProfile;
